import React, { Component, Fragment, createRef } from 'react';
import './InviteShareList.scss';
import { Helmet } from 'react-helmet';
import searchIcon from '../../assets/images/invite/icon_search@2x.png';
import copy from 'copy-to-clipboard';
import { Toast, Icon } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import Poster from '../../components/Poster/Poster';

class InviteShareList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 'team',
      codeUrl: '', //二维码
      showCode: false, //展示二维码
      witchTab: '0',
      codeList: [],
      codepageSize: 15,
      codepageNumber: 1,
      codeListTagName: '',
      codeListTotal: 0,
      linkList: [],
      linkpageSize: 15,
      linkpageNumber: 1,
      linkListTagName: '',
      linkListTotal: 0,
      isShowPoster: false,
      posterUrl: '',
      posterPostData: {},
    }
    this.recordListRef = createRef();
  }

  componentDidMount() {
    this.getCodeList();
    this.getLinkList();
    Http.post('/tag/qrcode/check', {
      accountId: '100338',
      tagRelationId: '1466973203003842562'
    })
  }

  getCodeList = async () => {
    if (this.state.codeListTotal && this.state.codeList && (this.state.codeList.length === this.state.codeListTotal)) {
      return;
    }
    const path  = '/tag/relation/lists';
    const postData = {
      pageSize: this.state.codepageSize,
      pageNumber: this.state.codepageNumber,
      name: this.state.codeListTagName,
      productSpreadId: this.props.location.state.productID,
    }
    const res = await Http.post(path, postData);
    if (res.code === 0 && res.data.content && res.data.content.length > 0) {
      const arr = this.state.codeList;
      this.setState({
        codeList: arr.concat(res.data.content),
        codepageNumber: (this.state.codepageNumber + 1),
        codeListTotal: res.data.total
      })
    }
  }

  getLinkList = async () => {
    if (this.state.linkListTotal && this.state.linkList && (this.state.linkList.length === this.state.linkListTotal)) {
      return;
    }
    const path  = '/tag/relation/lists';
    const postData = {
      pageSize: this.state.linkpageSize,
      pageNumber: this.state.linkpageNumber,
      name: this.state.linkListTagName,
      productSpreadId: this.props.location.state.productID,
    }
    const res = await Http.post(path, postData);
    if (res.code === 0 && res.data.content && res.data.content.length > 0) {
      const arr = this.state.linkList;
      this.setState({
        linkList: arr.concat(res.data.content),
        linkpageNumber: (this.state.linkpageNumber + 1),
        linkListTotal: res.data.total
      })
    }
  }

  changeTab = (tab) => {
    this.setState({
      witchTab: tab
    });
  }

  handleScroll = (tab) => {
    if (this.recordListRef.current.clientHeight + this.recordListRef.current.scrollTop >= (this.recordListRef.current.scrollHeight - 10)) {
      tab === '0' ? this.getCodeList() : this.getLinkList();
    }
  }

  copyUrl = (link, status) => {
    if (status === 1) {
      return;
    }
    copy(link)
    copy(link)//防止copy在特殊情况下需要两边才成功

    // document.addEventListener('copy', (e) => {this.handleCopy(e, link)});
    // document.execCommand('copy');
    Toast.info('复制成功！', 2);
  }

  changeCodeTagName = (e) => {
    this.setState({
      codeListTagName: e.target.value
    })
  }

  changeLinkTagName = (e) => {
    this.setState({
      linkListTagName: e.target.value
    })
  }

  // 保存弹窗的分享海报
  savaPoster = async (id, status) => {
    if (status === 1) {
      return;
    }
    this.setState({
      isShowPoster: true,
      posterUrl: '/source/manager/mergeLists',
      posterPostData: {
        tagRelationId: id,
        useType: 1,
        productSpreadId: this.props.location.state.productID,
      },
    })
  }

  hidePoster = () => {
    this.setState({
      isShowPoster: false,
      posterUrl: '',
      posterPostData: {}
    })
  }

  changeStatus = async (id, status) => {
    const path = '/tag/update/status';
    const postData = {
      id,
    }
    const res = await Http.post(path, postData);
    Toast.success(`${status === 0 ? '停用' : '启用'}成功`);
    if (res.code === 0) {
      this.setState({
        codeList: [],
        codepageSize: 15,
        codepageNumber: 1,
        codeListTagName: '',
        codeListTotal: 0,
        linkList: [],
        linkpageSize: 15,
        linkpageNumber: 1,
        linkListTagName: '',
        linkListTotal: 0,
      }, () => {
        this.getCodeList();
        this.getLinkList();
      })
    }
  }

  searchCode = () => {
    this.setState({
      codeList: [],
      codepageSize: 15,
      codepageNumber: 1,
      codeListTotal: 0,
    }, () => {
      this.getCodeList();
    });
  }

  searchLink = () => {
    this.setState({
      linkList: [],
      linkpageSize: 15,
      linkpageNumber: 1,
      linkListTotal: 0,
    }, () => {
      this.getLinkList();
    });
  }

  handleCopy = (e, url) => {
    // clipboardData 可能是 null
    e.clipboardData &&
      e.clipboardData.setData('text/plain', url);
    e.preventDefault();
    // removeEventListener 要传入第二个参数
    document.removeEventListener('copy', this.handleCopy);
  };

  render() {
    const { witchTab, codeList, linkList, isShowPoster, posterUrl, posterPostData } = this.state;
    return (
      <Fragment>
        <div className="invite-share-list-page">
          <Helmet><title>分享记录</title></Helmet>
          <div className="invite-share-list-page-tab">
            <div className={`${witchTab === '0' ? 'invite-share-list-page-tab-item-selected' : 'invite-share-list-page-tab-item'}`} onClick={() => {this.changeTab('0')}}>
              <span>二维码</span>
            </div>
            <div className={`${witchTab === '1' ? 'invite-share-list-page-tab-item-selected' : 'invite-share-list-page-tab-item'}`} onClick={() => {this.changeTab('1')}}>
              <span>链接</span>
            </div>
          </div>
          {witchTab === '0' && <div className="invite-share-list-page-content">
            <div className="invite-share-list-page-content-search">
              <input type="text" className="invite-share-list-page-content-search-input" placeholder="请输入标签名称" onChange={(e) => {this.changeCodeTagName(e)}} />
              <img src={searchIcon} alt="" className="invite-share-list-page-content-search-img" onClick={this.searchCode} />
            </div>
            <div className="invite-share-list-page-content-record-qrcode">
              <div className="invite-share-list-page-content-record-qrcode-title">
                <span className="invite-share-list-page-content-record-qrcode-title-item bq">标签</span>
                <span className="invite-share-list-page-content-record-qrcode-title-item time">生成时间</span>
                <span className="invite-share-list-page-content-record-qrcode-title-item time">失效时间</span>
                <span className="invite-share-list-page-content-record-qrcode-title-item operate">操作</span>
              </div>
              <div className="invite-share-list-page-content-record-qrcode-list" ref={this.recordListRef} onScroll={() => {this.handleScroll('0')}}>
                {codeList && codeList.length > 0 && codeList.map((ele, index) => {
                  return (
                    <div className="invite-share-list-page-content-record-qrcode-list-item" key={index}>
                      <div className="invite-share-list-page-content-record-qrcode-list-content bq">{ele.name}</div>
                      <div className="invite-share-list-page-content-record-qrcode-list-content time">{ele.createTime || ''}</div>
                      <div className="invite-share-list-page-content-record-qrcode-list-content time">{ele.expireTime || ''}</div>
                      <div className="invite-share-list-page-content-record-qrcode-list-content operate">
                        <span className={`mr ${ele.status === 1 ? 'gray' : ''}`} onClick={() => {this.savaPoster(ele.id, ele.status)}}>一键保存</span>
                        <span onClick={() => {this.changeStatus(ele.id, ele.status)}}>{ele.status === 0 ? '停用' : '启用'}</span>
                      </div>
                      {ele.over && <div className="invite-share-list-page-content-record-list-item-masker"></div>}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>}
          {witchTab === '1' && <div className="invite-share-list-page-content">
            <div className="invite-share-list-page-content-search">
              <input type="text" className="invite-share-list-page-content-search-input" placeholder="请输入标签名称" onChange={(e) => {this.changeLinkTagName(e)}} />
              <img src={searchIcon} alt="" className="invite-share-list-page-content-search-img" onClick={this.searchLink} />
            </div>
            <div className="invite-share-list-page-content-record-link">
              <div className="invite-share-list-page-content-record-link-title">
                <span className="invite-share-list-page-content-record-link-title-item bq">标签</span>
                <span className="invite-share-list-page-content-record-link-title-item lj">链接</span>
                <span className="invite-share-list-page-content-record-link-title-item time">生成时间</span>
                <span className="invite-share-list-page-content-record-link-title-item time">失效时间</span>
                <span className="invite-share-list-page-content-record-link-title-item operate">操作</span>
              </div>
              <div className="invite-share-list-page-content-record-link-list" ref={this.recordListRef} onScroll={() => {this.handleScroll('1')}}>
                {linkList && linkList.length > 0 && linkList.map((ele, index) => {
                  return (
                    <div className="invite-share-list-page-content-record-link-list-item" key={index}>
                      <div className="invite-share-list-page-content-record-link-list-content bq">{ele.name}</div>
                      <div className="invite-share-list-page-content-record-link-list-content lj">{ele.url}</div>
                      <div className="invite-share-list-page-content-record-link-list-content time">{ele.createTime || ''}</div>
                      <div className="invite-share-list-page-content-record-link-list-content time">{ele.expireTime || ''}</div>
                      <div className="invite-share-list-page-content-record-link-list-content operate">
                        <span className={`mr ${ele.status === 1 ? 'gray' : ''}`} onClick={() => {this.copyUrl(ele.url, ele.status)}}>复制</span>
                        <span onClick={() => {this.changeStatus(ele.id, ele.status)}}>{ele.status === 0 ? '停用' : '启用'}</span>
                      </div>
                      {ele.over && <div className="invite-share-list-page-content-record-link-list-item-masker"></div>}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>}
        </div>
        {isShowPoster && <div className='mask' >
          <div className="topClose" onClick={this.hidePoster}>
            <Icon type="cross" />
          </div>
          <Poster path={posterUrl} postData={posterPostData} />
        </div>}
      </Fragment>
    )
  }
}

export default InviteShareList;
